import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {GetServerSideProps} from 'next'
import {useEffect, useState, useRef, ReactEventHandler} from 'react'
//@ts-ignore
import {useLottie} from '@/hooks/useLottie'
import classNames from 'classnames'
import {useActivity} from '@/pages/activity/tenyears'
import {ActivityId, CombineImage_Map, IMAGE_MAP, TenAcTitle} from '@/constants/activityCdn'
import TitleBar from '@/components/TitleBar'
import {Swiper, Toast} from 'gotu-ui'
import {SubActivityModule, doMission} from '@/service/activity'
import {useUaParam} from '@/pages/_app'
import {openWindow} from '@/plugins/bridge'
import {haboClickReport} from '@/plugins/habo'
import {useCombine} from '@/pages/activity/tenyears/combine'
import {MissonTypeEnum} from '@/service/types/enum'
const styles = require('./style.module.less')
interface ModuleProps {
  subActivityModuleList: SubActivityModule[],
  childRef: any,
  activityPhase:number
}

const Module = (props: ModuleProps) => {
    const {
        subActivityModuleList,
        childRef,
        activityPhase,
    } = props
    const {
        isApp,
        visualCenterPosition = 0,
        source,
        fromId,
    } = useUaParam()
    const {getData, swiperRef} = useCombine()
    const videoRef = useRef<any>(null)
    const [isPlaying, setIsPlaying] = useState(false)
    const goUrl = async (item: SubActivityModule, index:number) => {
        const {
            jumpUrl,
            isLock,
            lockToast,
            videoUrl,
        } = item
        haboClickReport('十周年子活动板块点击', {source, moduleid: index, activity_id: ActivityId})
        if (isLock) {
            return Toast.show(lockToast || '视频未解锁，请耐心等待')
        }
        if (videoUrl) {
            const params = {fromId, missionType: MissonTypeEnum.video, operationType: 1}
            doMission(params).then(() => {
                getData()
            })
            // handleFullscreen()
            return
        }
        // 十节课 、社区 点击时完成任务 ，跳转
        if (item.missionType === MissonTypeEnum.lessons) {
            const params = {fromId, missionType: MissonTypeEnum.lessons, operationType: 1}
            doMission(params)
        }
        if (item.missionType === MissonTypeEnum.community) {
            const params = {fromId, missionType: MissonTypeEnum.community, operationType: 1}
            doMission(params)
        }
        if (isApp) {
            openWindow(jumpUrl, 'hide', 'hide')
        } else {
            window.open(jumpUrl)
        }
    }

    const swiperChange = (index: number) => {
        const item = subActivityModuleList[index]
        if (item.videoUrl && !item.isLock) {
            // videoRef.current && videoRef.current.play()
        } else {
            videoRef.current && videoRef.current.pause()
        }
        haboClickReport('十周年各板块曝光', {source, moduleid: index, activity_id: ActivityId})
    }
    const handlePlay = () => {
        setIsPlaying(true)
    }

    const handlePause = () => {
        setIsPlaying(false)
    }
    const changePlay = () => {
        if (videoRef.current.paused) {
            return videoRef.current.play()
        }
        else {
            return videoRef.current.pause()
        }
    }
    const handleFullscreen = () => {
        if (videoRef.current.requestFullscreen) {
            videoRef.current.requestFullscreen()
        } else if (videoRef.current.mozRequestFullScreen) { /* Firefox */
            videoRef.current.mozRequestFullScreen()
        } else if (videoRef.current.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
            videoRef.current.webkitRequestFullscreen()
        } else if (videoRef.current.msRequestFullscreen) { /* IE/Edge */
            videoRef.current.msRequestFullscreen()
        } else if (videoRef.current.webkitEnterFullscreen) { /* iOS Safari */
            videoRef.current.webkitEnterFullscreen()
        } else {
            Toast.show('浏览器不支持全屏')
        }
        if (videoRef.current.paused) {
            return videoRef.current.play()
        }
    }
    useEffect(() => {
        haboClickReport('十周年各板块曝光', {source, moduleid: visualCenterPosition, activity_id: ActivityId})
    }, [])

    const items = subActivityModuleList.map((item, index) => {
        return (
            <Swiper.Item key={index}>
                <div
                    className={styles.swiperbox}
                    onClick={() => goUrl(item, index)}
                >
                    {
                        (item.videoUrl && !item.isLock) && (
                            <div>
                                <video
                                    className='rd8 w96% h100%'
                                    ref={videoRef}
                                    src={item.videoUrl}
                                    controls={false}
                                    poster={item.coverUrl}
                                    onPlay={handlePlay}
                                    onPause={handlePause}
                                    preload='auto'
                                    onClick={changePlay}
                                ></video>
                                <div
                                    className='poa w20% r0 b0 h50%'
                                    onClick={handleFullscreen}
                                >
                                    <I

                                        className='poa r40% b16%'
                                        src='https://i.gsxcdn.com/2454727479_lxhcco1h.svg'
                                        width={20}
                                    ></I>
                                </div>
                                {
                                    !isPlaying && (
                                        <I
                                            className={classNames('center mr2%')}
                                            src='https://i.gsxcdn.com/2453771750_2o8xtfom.svg'
                                            width={20}
                                            onClick={changePlay}
                                        ></I>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        (!item.videoUrl || item.isLock) && (
                            <I
                                className='rd8 w96% hauto'
                                width={450}
                                quality={100}
                                src={item.coverUrl}
                            ></I>
                        )
                    }
                    {
                        activityPhase !== 2 && (
                            <div className={styles['cake-box']}>
                                {
                                    (activityPhase !== 2 && item.fragmentStatus !== 1) && (
                                        <I
                                            src={CombineImage_Map.sub_cake}
                                            width={34}
                                            height={34}
                                        ></I>
                                    )
                                }
                                {
                                    (activityPhase !== 2 && item.fragmentStatus === 1) && (
                                        <I
                                            src={CombineImage_Map.sub_cake_gray}
                                            width={34}
                                            height={34}
                                        ></I>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        item.isLock && (
                            <I
                                className='poa t50% l45% translate-50%-50%'
                                src={CombineImage_Map.child_lock}
                                width={36}
                                height={36}
                            ></I>
                        )
                    }
                    <div className='poa #fff fs14 fw600 l12 b10'>
                        {item.name}
                        <br></br>
                        <span className='fs12 fw400 opacity0.6'>{ item.description}</span>
                    </div>
                </div>
            </Swiper.Item>
        )
    })
    return (
        <div
            ref={childRef}
            className={classNames({[styles.child]: true})}
        >
            <div className='w100% fc por'>
                <img
                    src={CombineImage_Map.child_title}
                    className='w100% hauto block'
                />
                {/* <I
                    className='w100% hauto block'
                    width={343}
                    height={66}
                    src={CombineImage_Map.child_title}
                    quality={100}
                >
                </I> */}
            </div>
            <div className='bg#fff rdt0 rdl12 rdr12 pl16 pb13 mt-1'>
                <div className='mb12'>收集蛋糕切块，拼成蛋糕必得奖</div>
                <Swiper
                    defaultIndex={visualCenterPosition}
                    className='flex1'
                    indicator={() => null}
                    ref={swiperRef}
                    trackOffset={10}
                    slideSize={80}
                    style={{'--border-radius': '8px'}}
                    onIndexChange={swiperChange}
                >
                    {items}
                </Swiper>
            </div>
        </div>
    )
}

export default Module
